import * as THREE from 'three';
import { gsap } from 'gsap/gsap-core';
import Experience from '../Experience.js';

export default class GParticles {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.sizes = this.experience.sizes;
    this.debug = this.experience.debug; 
    this.updateAnimation = false

    this.bgTl = gsap.timeline({paused: true})

    // this.resources = this.experience.resources;
    // this.model = this.resources.items.particleModel;

    this.setParticles();
  }

  setParticles() {
    // Particle count
    const particleCount = 150;

    // Create a BufferGeometry for the particles
    const particles = new THREE.BufferGeometry();
    const positions = new Float32Array(particleCount * 3);
    const colors = new Float32Array(particleCount * 3);
    const sizes = new Float32Array(particleCount);
    const speeds = new Float32Array(particleCount);

    // Populate the buffers with random data
    for (let i = 0; i < particleCount; i++) {
      // Random positions
      const x = (Math.random() - 0.5) * 150;
      const y = (Math.random() - 0.5) * 150;
      const z = (Math.random() - 0.5) * 150;
      positions.set([x, y, z], i * 3);

     // Random color selection: white, gray, blue, pink
  const colorType = Math.random();
  let r, g, b;

  if (colorType < 0.16) {
    r = 0.580392157; g = 0.529411765; b = 0.898039216;
  } else if (colorType > 0.16 && colorType < 0.33) {
      r = 0
      g = 0.650980392
      b = 0.6
  } else if (colorType > 0.33 && colorType < 0.55) {
      r = 0.207843137
      g = 0.623529412
      b = 0.992156863
  } else if (colorType > 0.55 && colorType < 0.66) {
    r = 0.929411765
    g = 0.729411765
    b = 0
  } else if (colorType > 0.66 && colorType < 0.83) {
    r = 0.258823529
    g = 0.490196078
    b = 0.631372549
  } else {
    
    r = 0.290196078
    g = 0.819607843
    b = 1
  }
      colors.set([r, g, b], i * 3);

      // Random sizes
      sizes[i] = Math.random() * 2.5 + 0.5;

      // Random speeds
      speeds[i] = Math.random() * 2.0 + 1.0; // Random oscillation speed
    }

    // Assign attributes to the geometry
    particles.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    particles.setAttribute('color', new THREE.BufferAttribute(colors, 3));
    particles.setAttribute('size', new THREE.BufferAttribute(sizes, 1));
    particles.setAttribute('speed', new THREE.BufferAttribute(speeds, 1));

    const vertexShader = `
    attribute float size;
    attribute float speed;
    varying vec3 vColor;
  
    uniform float time;
    uniform float positionTime;
    uniform float minScale;
    uniform float maxScale;
    uniform float scaleTime;
  
    void main() {
      vColor = color;
  
      // Oscillation effect
      vec3 oscillatedPosition = position + vec3(
        sin(speed * time + position.x) * 0.2,
        cos(speed * time + position.y) * 0.2,
        // sin(speed * time + position.z) * 0.1
        position.z

      );
  
      oscillatedPosition *= vec3(positionTime * (speed * 0.2));
      // oscillatedPosition.z *= -positionTime * (speed * 0.4);
  
      // Calculate the particle size
      float scale = minScale + (maxScale - minScale) * (0.5 + 0.5 * sin(speed * time * .5)); // Range: minScale to maxScale
      gl_PointSize = size * scale * speed * scaleTime; // Adjust size dynamically
      gl_Position = projectionMatrix * modelViewMatrix * vec4(oscillatedPosition, 1.0);
    }
  `;
    // Fragment Shader
    const fragmentShader = `
    varying vec3 vColor;

void main() {
    // Distance from the center of the particle
    float dist = length(gl_PointCoord - vec2(0.5));
    
    // Soft edges with a blur
    float alpha = smoothstep(0.4, 0.0, dist) * 0.3; // Cap opacity at 0.5

    // Set the particle color with limited transparency
    gl_FragColor = vec4(vColor, alpha);

    // Discard pixels outside the particle's visible range
    if (dist > 0.5) {
        discard;
    }
}
    `;

    // Material with the shaders
    this.particleMaterial = new THREE.ShaderMaterial({
      uniforms: {
        time: { value: 0.0 },
        positionTime: {value: 0.0},
        scaleTime: {value:0.0},
        minScale: { value: 10.0 }, // Minimum scale
        maxScale: { value: 25.0 }, // Maximum scale
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      transparent: true,
      vertexColors: true,
      depthWrite: false,
      blending: THREE.AdditiveBlending
    });

    // Create the Points object
    this.particleSystem = new THREE.Points(particles, this.particleMaterial);
    this.scene.add(this.particleSystem);
    this.particleSystem.visible = false


    this.bgTl
      .set(this.particleSystem, {visible: true}, 0)
      .to(this.particleMaterial.uniforms.positionTime, { ease:'none', value: 1.0, duration: 1}, 0)
      .to(this.particleMaterial.uniforms.scaleTime, { ease:'none', value: 1.0, duration: 1}, 0)
  }


  update(){
      this.particleMaterial.uniforms.time.value += 0.01;
  }
}
